import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { JupiterTheme } from '../../theme/types';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
    },
    childrenContainer: {
      position: 'relative',
      height: '40px',
    },

    loadingIconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    standaloneContainer: {
      height: '100%',
      margin: 'auto',
    },
  })
);

export interface LoadingSpinnerProps {
  children?: React.ReactNode;
  className?: string;
  size?: number;
}

const LoadingSpinner = ({
  children,
  size = 40,
  className: classNameProp,
}: LoadingSpinnerProps) => {
  const classes = useStyles();

  const spinnerContainer = (className: string) => (
    <div
      aria-live="polite"
      aria-busy="true"
      className={clsx(className, classNameProp)}
    >
      <CircularProgress size={size} color="primary" />
    </div>
  );

  return children ? (
    <div className={classes.root}>
      {spinnerContainer(classes.loadingIconContainer)}
      <div className={classes.childrenContainer}>{children}</div>
    </div>
  ) : (
    spinnerContainer(
      clsx(classes.loadingIconContainer, classes.standaloneContainer)
    )
  );
};

export default LoadingSpinner;
